export { default as textAdditionalClassName } from './TextAdditionalClassName';
export { default as dateFormatter } from './dateFormatter';
export { default as displayCountTimer } from './displayCountTimer';
export { default as getTodayOpeningHoursData } from './getTodayOpeningHoursData';
export { default as getDistanceBranchData } from './getDistanceBranchData';
export { default as capitalizeText } from './capitalizeText';
export { default as ContainsHTML } from './containsHtml';
export { default as SanitizeHTML } from './sanitizeHtml';
export { default as convertStringToSlug } from './convertStringToSlug';
export { default as getRandomNumber } from './getRandomNumber';
export { default as generateStructuredData } from './generateStructuredData';
export { default as navbarMenuList } from './navbarMenuList';
export { default as footerMenuList } from './footerMenuList';
export { default as convertSlugToNormalText } from './convertSlugToNormalText';
export { default as isCMSDashboard } from './isCMSDashboard';
export { default as validateAlphaNumeric } from './validateAlphaNumeric';
export { default as validateEmail } from './validateEmail';
export { default as validateFullName } from './validateFullName';
export { default as validateFullNameWithAllowEmoji } from './validateFullNameWithAllowEmoji';
export { default as validatePhoneNumber } from './validatePhoneNumber';
export { default as checkValidPhoneNumber } from './checkValidPhoneNumber';
export { default as trimText } from './trimText';
export { default as isIncludeSpecialCharacters } from './isIncludeSpecialCharacters';
export { default as isOnlyNumbers } from './isOnlyNumbers';
export { default as extractHexCodeFromString } from './extractHexCodeFromString';
export { default as preventInputNumberOnWheel } from './preventInputNumberOnWheel';
export { default as getCurrentYear } from './getCurrentYear';
export { default as formatDateToUTC } from './formatDateToUTC';
export { default as checkIsIsoCodeProvinceHaveBranch } from './checkIsIsoCodeProvinceHaveBranch';
export { default as checkIsCityNameHaveBranch } from './checkIsCityNameHaveBranch';
export { default as youtubeLinkParser } from './youtubeLinkParser';
export { default as extractFromCookies } from './extractFromCookies';
export { default as getLastURLSegment } from './getLastUrlSegment';
export { default as generateNCPDetailUrl } from './generateNCPDetailUrl';
export { default as generateFilterNewCar } from './generateFilterNewCar';
export { default as generateQueryParams } from './generateQueryParams';
export { default as generateNCPMenuBarList } from './generateNCPMenuBarList';
export { default as redirectUrl } from './redirectUrl';
export { default as handleEnableDisableScrollMobile } from './handleEnableDisableScrollMobile';
export { default as setCookie } from './setCookie';
export { default as generateFilterServicePackages } from './generateFilterServicePackages';
export { default as discountPrice } from './discountPrice';
export { default as triggerNativeMessage } from './triggerNativeMessage';
export { default as calculateDiscount } from './calculateDiscount';
export { default as isIncludeSpecialCharactersWithoutSpaces } from './isIncludeSpecialCharactersWithoutSpaces';
export { default as parseHtmlToString } from './parseHtmlToString';
export { default as formatTextOnly } from './formatTextOnly';
export { default as dateFormatterInquiry } from './dateFormatterInquiry';
export { default as cityToIsoCode } from './cityIsoCode';
export { default as validateImageExtension } from './validateImageExtension';
export { default as resizeBannerPackageCouponService } from './resizeBannerPackageCouponService';
export { default as slugNewsFormatter } from './slugNewsFormatter';
export { default as getPickUpLabelAccessories } from './getPickUpLabelAccessories';
export { default as formatDateMyAccount } from './formatDateMyAccount';
export { default as cn } from './cn';
export { default as validateVIN } from './validateVIN';
export { default as compareDiffDates } from './compareDiffDates';
export { default as generateCarListsFromData } from './generateCarListsFromData';
export { default as formatPhoneNumber } from './formatPhoneNumber';
